import { render, staticRenderFns } from "./RestaurantMenuProductsListItem.vue?vue&type=template&id=9b32bd60"
import script from "./RestaurantMenuProductsListItem.vue?vue&type=script&lang=ts"
export * from "./RestaurantMenuProductsListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports